export default "__VITE_ASSET__DfaZn_yI__"